var $a16eae39a66f3afd$exports = require("./ar-AE.main.js");
var $be973442240b2918$exports = require("./bg-BG.main.js");
var $a1709037331f64d7$exports = require("./cs-CZ.main.js");
var $1896523498fa2f44$exports = require("./da-DK.main.js");
var $169837a5a815615d$exports = require("./de-DE.main.js");
var $cfb55132d6925036$exports = require("./el-GR.main.js");
var $384a6c8de1da1e62$exports = require("./en-US.main.js");
var $be8241903709dc6e$exports = require("./es-ES.main.js");
var $63e1eb192205ecbf$exports = require("./et-EE.main.js");
var $41dc33071b9981dc$exports = require("./fi-FI.main.js");
var $c75ba81d7768253e$exports = require("./fr-FR.main.js");
var $f678f4bf27dcdd12$exports = require("./he-IL.main.js");
var $d23f6e75dc589b55$exports = require("./hr-HR.main.js");
var $439e34e0a9a3f4c1$exports = require("./hu-HU.main.js");
var $449973ba87982f00$exports = require("./it-IT.main.js");
var $902560907618d6e6$exports = require("./ja-JP.main.js");
var $8c0f39c970bc2860$exports = require("./ko-KR.main.js");
var $db03bc54746c5caa$exports = require("./lt-LT.main.js");
var $3f356a0921f4d37a$exports = require("./lv-LV.main.js");
var $1265d19da9735bfb$exports = require("./nb-NO.main.js");
var $7b57f991f3f6edd1$exports = require("./nl-NL.main.js");
var $04fe5f1360210d7c$exports = require("./pl-PL.main.js");
var $e64ffd0cafbe4c46$exports = require("./pt-BR.main.js");
var $f7b4a5fc25c8f238$exports = require("./pt-PT.main.js");
var $cf72ee454c27a2e7$exports = require("./ro-RO.main.js");
var $a41511fa599c2cbe$exports = require("./ru-RU.main.js");
var $2fedc389afac088d$exports = require("./sk-SK.main.js");
var $b0aebb8d8c040cc9$exports = require("./sl-SI.main.js");
var $67017d9b82b5d17e$exports = require("./sr-SP.main.js");
var $833e86f5dac82c23$exports = require("./sv-SE.main.js");
var $5b72687d362158b0$exports = require("./tr-TR.main.js");
var $5d2b1be67024bd70$exports = require("./uk-UA.main.js");
var $644f5cd034787834$exports = require("./zh-CN.main.js");
var $11c20589c8b82ee8$exports = require("./zh-TW.main.js");
module.exports = {
  "ar-AE": $a16eae39a66f3afd$exports,
  "bg-BG": $be973442240b2918$exports,
  "cs-CZ": $a1709037331f64d7$exports,
  "da-DK": $1896523498fa2f44$exports,
  "de-DE": $169837a5a815615d$exports,
  "el-GR": $cfb55132d6925036$exports,
  "en-US": $384a6c8de1da1e62$exports,
  "es-ES": $be8241903709dc6e$exports,
  "et-EE": $63e1eb192205ecbf$exports,
  "fi-FI": $41dc33071b9981dc$exports,
  "fr-FR": $c75ba81d7768253e$exports,
  "he-IL": $f678f4bf27dcdd12$exports,
  "hr-HR": $d23f6e75dc589b55$exports,
  "hu-HU": $439e34e0a9a3f4c1$exports,
  "it-IT": $449973ba87982f00$exports,
  "ja-JP": $902560907618d6e6$exports,
  "ko-KR": $8c0f39c970bc2860$exports,
  "lt-LT": $db03bc54746c5caa$exports,
  "lv-LV": $3f356a0921f4d37a$exports,
  "nb-NO": $1265d19da9735bfb$exports,
  "nl-NL": $7b57f991f3f6edd1$exports,
  "pl-PL": $04fe5f1360210d7c$exports,
  "pt-BR": $e64ffd0cafbe4c46$exports,
  "pt-PT": $f7b4a5fc25c8f238$exports,
  "ro-RO": $cf72ee454c27a2e7$exports,
  "ru-RU": $a41511fa599c2cbe$exports,
  "sk-SK": $2fedc389afac088d$exports,
  "sl-SI": $b0aebb8d8c040cc9$exports,
  "sr-SP": $67017d9b82b5d17e$exports,
  "sv-SE": $833e86f5dac82c23$exports,
  "tr-TR": $5b72687d362158b0$exports,
  "uk-UA": $5d2b1be67024bd70$exports,
  "zh-CN": $644f5cd034787834$exports,
  "zh-TW": $11c20589c8b82ee8$exports
};